import {
  FaArrowLeft,
  FaUser,
  FaEnvelope,
  FaPhone,
  FaGlobe,
} from "react-icons/fa";
import { MdSchool } from "react-icons/md";
import { BsChevronRight } from "react-icons/bs";
import Button from "../../../../ReusableComponent/Button"

const SectionCard = ({ icon, title, subtitle, children, iconBg }) => (
  <div className="card bg-dark border-primary mb-4">
    <div className="card-body p-4">
      <div className="d-flex align-items-center mb-4">
        <div
          className="rounded-3 p-2 me-3 shadow"
          style={{ background: iconBg || "rgba(59,130,246,0.1)" }}
        >
          {icon}
        </div>
        <div>
          <h4 className="text-light mb-1">{title}</h4>
          <small className="text-muted">{subtitle}</small>
        </div>
      </div>
      {children}
    </div>
  </div>
);

const Step1PersonalDetails = ({ onNext }) => {
  // Contact Inputs
  const contactFields = [
    { label: "Full Name *", type: "text", placeholder: "Enter full name" },
    {
      label: "Email *",
      type: "email",
      placeholder: "your@email.com",
      icon: (
        <FaEnvelope
          className="position-absolute text-muted"
          style={{ left: 12, top: 12 }}
        />
      ),
      ps: "ps-5",
    },
    {
      label: "Phone *",
      type: "tel",
      placeholder: "+1 (555) 123-4567",
      icon: (
        <FaPhone
          className="position-absolute text-muted"
          style={{ left: 12, top: 12 }}
        />
      ),
      ps: "ps-5",
    },
    {
      label: "Emergency Contact",
      type: "tel",
      placeholder: "Emergency number",
    },
  ];

  // Academic Dropdowns
  const graduationYears = [2024, 2025, 2026, 2027, 2028];
  const tshirtSizes = ["XS", "S", "M", "L", "XL", "XXL"];
  const experienceLevels = [
    { value: "beginner", label: "Beginner (0-1 yrs)" },
    { value: "intermediate", label: "Intermediate (1-3 yrs)" },
    { value: "advanced", label: "Advanced (3+ yrs)" },
    { value: "expert", label: "Expert (5+ yrs)" },
  ];

  // Country Options
  const countries = [
    "United States",
    "India",
    "United Kingdom",
    "Canada",
    "Germany",
    "France",
    "Australia",
    "Japan",
    "South Korea",
    "Brazil",
    "Other",
  ];

  return (
    <>
      {/* Form Sections */}
      <section className="row mx-0 py-5 d-flex justify-content-center align-items-center">
        <div className="col-md-11 col-12">
          <div className="row mx-0 g-4 justify-content-center">
            {/* Contact Information */}
            <div className="col-md-6">
              <SectionCard
                icon={<FaUser className="text-white" />}
                title="Contact Information"
                subtitle="How can we reach you?"
              >
                <div className="row mx-0 g-3">
                  {contactFields.map((field, idx) => (
                    <div className="col-12" key={idx}>
                      <div className="mb-2">
                      <label className="form-label text-light">
                        {field.label}
                      </label>
                      </div>
                      <div className="position-relative">
                        {field.icon}
                        <input
                          type={field.type}
                          className={`form-control bg-dark text-light border-secondary ${
                            field.ps || ""
                          }`}
                          placeholder={field.placeholder}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </SectionCard>
            </div>

            {/* Academic Background */}
            <div className="col-md-6">
              <SectionCard
                icon={<MdSchool className="text-info" />}
                title="Academic Background"
                subtitle="Your educational details"
              >
                <div className="row mx-0 g-3">
                  <div className="col-12">
                    <div className="mb-2">
                    <label className="form-label text-light">
                      University *
                    </label>
                    </div>
                    <input
                      type="text"
                      className="form-control bg-dark text-light border-secondary"
                      placeholder="University name"
                    />
                  </div>

                  {/* Graduation Year */}
                  <div className="col-6">
                    <div className="mb-2">
                    <label className="form-label text-light">
                      Graduation Year *
                    </label>
                    </div>
                    <select className="form-select bg-dark text-light border-secondary">
                      <option value="">Select year</option>
                      {graduationYears.map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* T-shirt Size */}
                  <div className="col-6">
                    <div className="mb-2">
                    <label className="form-label text-light">
                      T-shirt Size
                    </label>
                    </div>
                    <select className="form-select bg-dark text-light border-secondary">
                      {tshirtSizes.map((size) => (
                        <option key={size} value={size}>
                          {size}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Programming Experience */}
                  <div className="col-12">
                    <div className="mb-2">
                    <label className="form-label text-light">
                      Programming Experience
                    </label>
                    </div>
                    <select className="form-select bg-dark text-light border-secondary">
                      <option value="">Select level</option>
                      {experienceLevels.map((lvl) => (
                        <option key={lvl.value} value={lvl.value}>
                          {lvl.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </SectionCard>
            </div>
          </div>

          {/* Location Info */}
          <div className="row mt-4">
            <div className="col-12">
              <SectionCard
                icon={<FaGlobe className="text-success" />}
                title="Location Information"
                subtitle="Where are you joining us from?"
                iconBg="rgba(34,197,94,0.1)"
              >
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="mb-2">
                    <label className="form-label text-light">Country *</label>
                    </div>
                    <select className="form-select bg-dark text-light border-secondary">
                      <option value="">Select your country</option>
                      {countries.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-2">
                    <label className="form-label text-light">City *</label>
                    </div>
                    <input
                      type="text"
                      className="form-control bg-dark text-light border-secondary"
                      placeholder="Enter city"
                    />
                  </div>
                </div>
              </SectionCard>
            </div>
          </div>

          {/* Buttons */}
          <div className="row mt-5">
            <div className="col-12 d-flex justify-content-between">
              <Button variant="back">
                <FaArrowLeft className="me-2" /> Back
              </Button>
              <Button variant="gradient" onClick={onNext}>
                Continue to Payment <BsChevronRight className="ms-2" />
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step1PersonalDetails;
